import { render, staticRenderFns } from "./PracticalMatterForm.vue?vue&type=template&id=7db156ea"
import script from "./PracticalMatterForm.vue?vue&type=script&lang=js"
export * from "./PracticalMatterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports